import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { useId } from '@radix-ui/react-id';
import { Flex } from '../../layout/Flex.mjs';
import { useLinearLocale } from '../../locale/LocaleContext.mjs';
import { Switch } from '../../switch/Switch.mjs';
import { Typography } from '../../typography/Typography.mjs';
import { useDatePickerContext } from '../context/datePickerContext.mjs';
import { localeValues } from './localeValues.mjs';
import ModeToggleTrigger from './ModeToggleTrigger.mjs';

const MODE_TOGGLE_SWITCH_NAME = "ModeToggleSwitch";
const ModeToggleSwitch = ({
  __scopeDatePicker,
  switchProps,
  ...props
}) => {
  const { locale } = useLinearLocale();
  const { mode } = useDatePickerContext(
    MODE_TOGGLE_SWITCH_NAME,
    __scopeDatePicker
  );
  const switchId = useId();
  return /* @__PURE__ */ jsxs(StyledFlex, { align: "center", justify: "between", ...props, children: [
    /* @__PURE__ */ jsx(Typography, { asChild: true, weight: 600, color: "grayDark", children: /* @__PURE__ */ jsx("label", { htmlFor: switchId, children: localeValues[locale].modeToggleSwitchLabel }) }),
    /* @__PURE__ */ jsx(ModeToggleTrigger, { asChild: true, children: /* @__PURE__ */ jsx(
      Switch,
      {
        id: switchId,
        size: "small",
        ...switchProps,
        checked: mode === "range"
      }
    ) })
  ] });
};
const StyledFlex = styled(Flex, {
  width: "100%",
  px: 14,
  height: 32,
  gap: 8
});

export { ModeToggleSwitch as default };
//# sourceMappingURL=ModeToggleSwitch.mjs.map
